export const types = {};
types.SET_LOADING_INDICATOR_VISIBILITY = 'SET_LOADING_INDICATOR_VISIBILITY';

export const setLoadingIndicatorVisibility = (loadingIndicatorVisibility) => ({
  type: types.SET_LOADING_INDICATOR_VISIBILITY,
  payload: {
    loadingIndicatorVisibility,
  },
});